<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.ponto"
        ref="RkmDataTable"
        sort-by="descricao"
    >
        <template v-slot:cell(actions)="{ item }">
            <template v-if="!$scopedSlots.actions">
                <rkm-button
                    @click="handleEdit(item.id)"
                    color="primary"
                    small
                    title="Editar"
                    autorize="edit-transporte-paciente-ponto"
                >
                    <rkm-icon icon="pen"/>
                </rkm-button>

                <rkm-button
                    v-if="!item.bloqueado"
                    @click="handleBlock(item.id, false)"
                    color="dark"
                    small
                    title="Inativar"
                    autorize="update-transporte-paciente-ponto"
                >
                    <rkm-icon icon="ban"/>
                </rkm-button>

                <rkm-button
                    v-else
                    @click="handleBlock(item.id, true)"
                    color="success"
                    small
                    title="Ativar"
                    autorize="update-transporte-paciente-ponto"
                >
                    <rkm-icon icon="check-circle"/>
                </rkm-button>

                <rkm-button
                    @click="handleDestroy(item.id)"
                    color="danger"
                    small
                    title="Excluir"
                    autorize="destroy-transporte-paciente-ponto"
                >
                    <rkm-icon icon="trash"/>
                </rkm-button>

                <slot
                    name="actions"
                    :destino="item"
                />
            </template>
        </template>
    </rkm-data-table>
</template>

<script>

// Mixins.
import { error, repository, stringCase} from '@/mixins';

export default {
    computed: {
        fields() {
            return [
                {
                    key: 'descricao',
                    label: 'Descrição',
                    name: 'descricao',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'tipo',
                    label: 'Tipo',
                    name: 'cadastroLogradouroTipo.descricao',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'logradouro',
                    label: 'Logradouro',
                    name: 'cadastroLogradouro.nome',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'numero',
                    label: 'Número',
                    name: 'transportePacientePonto.numero',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'bairro',
                    label: 'Bairro',
                    name: 'cadastroBairro.nome',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'municipio',
                    label: 'Município',
                    name: 'intranet.cadastroMunicipio.nome',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'status',
                    label: 'Status',
                    name: 'transportePacientePonto.bloqueado',
                    searchable: true,
                    sortable: true
                },
                {
                    class: 'col-min text-center',
                    key: 'actions',
                    label: 'Ações',
                },
            ];
        }
    },
    created() {
        this.repositories = {
            ponto: this.getConectaSusRepository('transportePaciente.ponto')
        }
    },
    methods: {
        handleEdit(id) {
            this.$router.push({ name: 'transporte-paciente-ponto-edit', params: { id: id } })
        },
        handleBlock(id, ativar) {

            const bloqueio = () => this.repositories.ponto.bloquear(id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showConfirmation(
                `Deseja realmente ${ativar ? 'ativar' : 'inativar'} o ponto?`,
                bloqueio,
                null,
                this.handleError
            )
        },
        handleDestroy(id) {
            const exclusao = () => this.repositories.ponto.destroy(id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation(
                'Deseja realmente excluir o ponto?',
                exclusao,
                this.handleError
            )
        },
    },
    mixins: [ error, repository, stringCase ],
};

</script>